import React, {useState} from "react";
import {useGlobalContext} from "../context/GlobalState";
import {Avatar, Button, Typography, Menu, MenuItem} from "@mui/material";
import LogoutIcon from '@mui/icons-material/Logout';

export function UserTab({open}) {
    const {user, logout} = useGlobalContext();
    const [anchorEl, setAnchorEl] = useState(null);

    const handleToggleMenu = (event, action) => {
        setAnchorEl(anchorEl ? null : event.currentTarget);
    };

    return (
        <>
            <Button
                id="user-tab"
                aria-controls="user-tab"
                aria-haspopup="true"
                onClick={handleToggleMenu}
                sx={{padding: 0, width: '100%', justifyContent: "flex-start"}}
            >
                <Avatar
                    variant="rounded"
                    sx={{backgroundColor: "primary.main", padding: 0, margin: 0}}
                >
                    {user?.firstName?.[0] + user?.lastName?.[0] || ""}
                </Avatar>
                <Typography
                    sx={{
                        ml: 1,
                        color: "primary.main",
                        justifyContent: "flex-start",
                        opacity: open ? 1 : 0,
                    }}
                >
                    {user?.firstName}
                </Typography>
            </Button>
            <Menu
                id="user-selection-menu"
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleToggleMenu}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                }}
            >
                <MenuItem onClick={logout}>
                    Logout
                    <LogoutIcon sx={{
                        ml: 1,
                        color: "primary.main"
                    }}/>
                </MenuItem>
            </Menu>
        </>
    );
}